const rootConst = 'MERCHANT';

export const CREATE_MERCHANT = `${rootConst}/CREATE_MERCHANT`;
export const UPDATE_MERCHANT_PROFILE = `${rootConst}/UPDATE_MERCHANT_PROFILE`;

export const LABEL_BY_TYPE = {
  company: {
    business_name: `Store Name`,
    name: `Representative's Name`,
  },
  individual: {
    business_name: 'Store Name',
    name: `Store Owner Name`,
  },
};

export const INIT_FORM = {
  first_name: '',
  last_name: '',
  email_address: '',
  business_name: '',
  mobile_number: '',
  password: '',
  password_confirmation: '',
  profile_type: {
    label: 'Company',
    value: 'company',
  },
  page_banner_url: '',
  business_logo: '',
  is_visible: false,
  merchant_type: '',
  business_category: [],
  business_facebook_account: '',
  business_instagram_account: '',
  business_twitter_account: '',
  distributor_uuid: '',
};
